// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/.pnpm/css-loader@6.11.0_webpack@5.107.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* System Configuration dialog: large, responsive, tabbed.
   Reuses the shared .modal backdrop + .titlebar/.dismiss styling from widgets.css;
   overrides the default 400px/centered-33% dialog sizing. */

.modal .dialog.system-config {
    width: min(960px, 92vw);
    height: min(760px, 88vh);
    top: 50%;
    padding-bottom: 0;

    display: flex;
    flex-direction: column;
    overflow: hidden;
}

/* tab row */
.system-config .tabs {
    display: flex;
    align-items: stretch;
    border-bottom: 1px solid var(--black-20);
    padding: 0 4px;
    user-select: none;
}

.system-config .tabs .tab {
    flex: 1;
    text-align: center;
    padding: 16px 8px;

    font-size: 15px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--black-45);

    cursor: pointer;
    border-bottom: 3px solid transparent;
    margin-bottom: -1px;
}

.system-config .tabs .tab:hover {
    color: var(--black-65);
}

.system-config .tabs .tab.active {
    color: var(--black-90);
    border-bottom-color: var(--black-80);
}

/* body grows to fill, scrolls if content overflows */
.system-config .body {
    flex: 1;
    overflow-y: auto;
    margin: 0;
    padding: 24px;
}

.system-config .body .placeholder {
    color: var(--black-45);
    font-size: 15px;
}

/* footer pinned at the bottom */
.system-config .actions {
    padding: 16px 0 18px;
    flex: 0 0 auto;
}

/* ===== MIDI tab ===== */
.system-config .midi-tab {
    max-width: 680px;
    margin: 0 auto;
}

.system-config .section-label {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    color: var(--blue-2);
    margin: 0 0 10px;
}

/* port selector */
.system-config .midi-ports {
    margin-bottom: 18px;
}

.system-config .ports {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
}

.system-config .ports .port {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    height: 30px;
    padding: 0 12px;
    border-radius: 15px;

    font-size: 13px;
    font-weight: 500;
    white-space: nowrap;

    color: var(--black-65);
    background-color: transparent;
    border: 1px solid var(--black-25);

    cursor: pointer;
    user-select: none;
}

.system-config .ports .port:hover {
    color: var(--black-85);
    border-color: var(--black-35);
}

.system-config .ports .port .check {
    font-size: 16px;
    display: none;
}

.system-config .ports .port.on {
    color: var(--black-90);
    background-color: var(--blue-1);
    border-color: var(--blue-2);
}

.system-config .ports .port.on .check {
    display: inline;
}

/* selected but disconnected */
.system-config .ports .port.bad {
    color: var(--red-3);
    border-color: var(--red-3);
    background-color: transparent;
}

.system-config .ports .port.bad .tag {
    font-size: 11px;
    opacity: 0.8;
}

.system-config .ports .clear {
    margin-left: auto;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.04em;
    color: var(--black-45);
    cursor: pointer;
    padding: 0 4px;
}

.system-config .ports .clear:hover {
    color: var(--black-80);
}

/* embedded MIDI manager fills the tab column */
.system-config .midi-browser.embed {
    width: 100%;
}

/* category filter bubbles (MIDI tab) — let the filter row span the full width */
.system-config .midi-browser.embed > .header {
    width: 100%;
}
.system-config .midi-browser.embed .header .left {
    gap: 12px;
}
.system-config .midi-browser.embed .cat-filters {
    display: flex;
    align-items: center;
    gap: 4px;
}
.system-config .midi-browser.embed .cat-filter {
    width: 26px;
    height: 26px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 13px;
    cursor: pointer;
    user-select: none;
    color: var(--black-45);
    border: 1px solid transparent;
}
.system-config .midi-browser.embed .cat-filter .symbols {
    font-size: 17px;
}
.system-config .midi-browser.embed .cat-filter:hover {
    color: var(--black-85);
    background: var(--black-10);
}
.system-config .midi-browser.embed .cat-filter.active {
    color: var(--black-90);
    background: var(--blue-1);
    border-color: var(--blue-2);
}

/* MIDI tab: "where these settings are saved" reference (collapsible) */
.system-config .storage-ref {
    margin-top: 16px;
    background: var(--black-02);
    border: 1px solid var(--black-10);
    border-radius: 5px;
    padding: 8px 12px;
}
.system-config .storage-ref > summary {
    cursor: pointer;
    color: var(--black-65);
    font-size: 12.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    user-select: none;
}
.system-config .storage-ref > summary:hover {
    color: var(--black-85);
}
.system-config .storage-ref .intro {
    color: var(--black-65);
    font-size: 13px;
    line-height: 1.5;
    margin: 12px 0 14px;
}

/* level table */
.system-config .lvl-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 12.5px;
    margin-bottom: 16px;
}
.system-config .lvl-table th {
    text-align: left;
    color: var(--black-45);
    font-weight: 600;
    padding: 4px 10px;
    border-bottom: 1px solid var(--black-15);
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}
.system-config .lvl-table td {
    padding: 6px 10px;
    border-bottom: 1px solid var(--black-10);
    color: var(--black-80);
}
.system-config .lvl-table tr:last-child td {
    border-bottom: none;
}

/* level badge */
.system-config .badge {
    display: inline-block;
    font-size: 10.5px;
    font-weight: 700;
    letter-spacing: 0.03em;
    padding: 2px 7px;
    border-radius: 10px;
    white-space: nowrap;
}
.system-config .badge.machine {
    color: #e7b766;
    background: rgba(231,183,102,0.13);
    border: 1px solid rgba(231,183,102,0.45);
}
.system-config .badge.session {
    color: #6fc3a6;
    background: rgba(111,195,166,0.13);
    border: 1px solid rgba(111,195,166,0.45);
}

/* icon legend */
.system-config .legend-title {
    color: var(--black-45);
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    margin: 0 0 8px;
}
.system-config .legend {
    display: flex;
    flex-direction: column;
    gap: 7px;
}
.system-config .legend .row {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 12.5px;
}
.system-config .legend .ico {
    width: 22px;
    flex: 0 0 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--black-65);
}
.system-config .legend .ico .symbols {
    font-size: 17px;
}
.system-config .legend .ico .nodeicon {
    width: 15px;
    height: 15px;
}
.system-config .legend .lbl {
    color: var(--black-85);
    font-weight: 600;
    min-width: 78px;
}
.system-config .legend .desc {
    color: var(--black-45);
    flex: 1;
}

/* ===== Devices + Backup tabs (shared layout) ===== */
.system-config :is(.devices-pane, .backup-pane) {
    max-width: 680px;
    margin: 0 auto;
}

.system-config :is(.devices-tab, .backup-tab) .help {
    color: var(--black-65);
    line-height: 1.55;
    margin: 0 0 14px;
    font-size: 13.5px;
}
.system-config :is(.devices-tab, .backup-tab) .help b {
    color: var(--black-85);
    font-weight: 600;
}
.system-config :is(.devices-tab, .backup-tab) code {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 12px;
    background: var(--black-10);
    color: var(--black-85);
    padding: 1px 5px;
    border-radius: 3px;
}

.system-config :is(.devices-tab, .backup-tab) .block.tight {
    margin-bottom: 16px;
}

/* Export / Import side-by-side cards */
.system-config :is(.devices-tab, .backup-tab) .cards {
    display: flex;
    gap: 14px;
    margin-bottom: 14px;
}
.system-config :is(.devices-tab, .backup-tab) .card {
    flex: 1;
    display: flex;
    flex-direction: column;
    background: var(--black-02);
    border: 1px solid var(--black-10);
    border-radius: 6px;
    padding: 14px 16px 16px;
}
.system-config :is(.devices-tab, .backup-tab) .card .help {
    flex: 1;
    margin-bottom: 12px;
}

.system-config :is(.devices-tab, .backup-tab) .action-row {
    display: flex;
    margin-top: 4px;
}

/* buttons (Export primary / Import danger-outline) */
.system-config :is(.devices-tab, .backup-tab) .cta {
    height: 34px;
    padding: 0 18px;
    gap: 8px;
    font-size: 13px;
    font-weight: 600;
    letter-spacing: 0.02em;
    white-space: nowrap;
}
.system-config :is(.devices-tab, .backup-tab) .cta .symbols {
    font-size: 18px;
}
.system-config :is(.devices-tab, .backup-tab) .cta.danger {
    background-color: transparent;
    color: var(--red-3);
    border: 1px solid var(--red-3);
    box-shadow: none;
}
.system-config :is(.devices-tab, .backup-tab) .cta.danger:hover {
    background-color: rgba(236,115,106,0.10);
    color: var(--red-3);
}

/* destructive warning banner */
.system-config :is(.devices-tab, .backup-tab) .warn {
    display: flex;
    gap: 10px;
    align-items: flex-start;
    background: rgba(183,40,40,0.12);
    border: 1px solid var(--red-1);
    border-left: 3px solid var(--red-3);
    border-radius: 4px;
    padding: 10px 12px;
    margin: 0 0 14px;
}
.system-config :is(.devices-tab, .backup-tab) .warn .symbols {
    color: var(--red-3);
    font-size: 20px;
    flex: 0 0 auto;
}
.system-config :is(.devices-tab, .backup-tab) .warn .txt {
    color: var(--black-80);
    line-height: 1.5;
    font-size: 13px;
}
.system-config :is(.devices-tab, .backup-tab) .warn .txt b {
    color: var(--red-3);
}

/* CSV column reference (collapsible) */
.system-config :is(.devices-tab, .backup-tab) details {
    background: var(--black-02);
    border: 1px solid var(--black-10);
    border-radius: 5px;
    padding: 8px 12px;
}
.system-config :is(.devices-tab, .backup-tab) summary {
    cursor: pointer;
    color: var(--black-65);
    font-size: 12.5px;
    font-weight: 600;
    letter-spacing: 0.04em;
    user-select: none;
}
.system-config :is(.devices-tab, .backup-tab) summary:hover {
    color: var(--black-85);
}
.system-config :is(.devices-tab, .backup-tab) .cols {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}
.system-config :is(.devices-tab, .backup-tab) .col {
    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
    font-size: 11.5px;
    padding: 3px 8px;
    border-radius: 3px;
    background: var(--black-10);
    color: var(--black-65);
    border: 1px solid var(--black-15);
}
.system-config :is(.devices-tab, .backup-tab) .col.req {
    color: var(--black-90);
    border-color: var(--blue-2);
    background: var(--blue-1);
}
.system-config :is(.devices-tab, .backup-tab) .cols-note {
    margin-top: 10px;
    color: var(--black-45);
    font-size: 12px;
}
.system-config :is(.devices-tab, .backup-tab) .cols-note .req-swatch {
    display: inline-block;
    width: 9px;
    height: 9px;
    border-radius: 2px;
    background: var(--blue-1);
    border: 1px solid var(--blue-2);
    vertical-align: middle;
    margin: 0 3px;
}

/* Backup: "what's in a backup" chips */
.system-config .backup-tab .items {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 12px;
}
.system-config .backup-tab .item {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-size: 12px;
    padding: 3px 9px 3px 7px;
    border-radius: 12px;
    background: var(--black-10);
    color: var(--black-80);
    border: 1px solid var(--black-15);
}
.system-config .backup-tab .item .symbols {
    font-size: 14px;
    color: var(--blue-2);
}
.system-config .backup-tab .items-note {
    margin-top: 10px;
    color: var(--black-45);
    font-size: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/sysconfig.css"],"names":[],"mappings":"AAAA;;4DAE4D;;AAE5D;IACI,uBAAuB;IACvB,wBAAwB;IACxB,QAAQ;IACR,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA,YAAY;AACZ;IACI,aAAa;IACb,oBAAoB;IACpB,wCAAwC;IACxC,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,iBAAiB;;IAEjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;;IAEtB,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA,qDAAqD;AACrD;IACI,OAAO;IACP,gBAAgB;IAChB,SAAS;IACT,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,oBAAoB;IACpB,cAAc;AAClB;;AAEA,yBAAyB;AACzB;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA,kBAAkB;AAClB;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,mBAAmB;;IAEnB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;;IAEnB,sBAAsB;IACtB,6BAA6B;IAC7B,iCAAiC;;IAEjC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,sBAAsB;IACtB,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA,8BAA8B;AAC9B;IACI,mBAAmB;IACnB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,+CAA+C;AAC/C;IACI,WAAW;AACf;;AAEA,gFAAgF;AAChF;IACI,WAAW;AACf;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,6BAA6B;AACjC;AACA;IACI,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,uEAAuE;AACvE;IACI,gBAAgB;IAChB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,WAAW;IACX,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,wCAAwC;IACxC,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,iBAAiB;IACjB,wCAAwC;IACxC,sBAAsB;AAC1B;AACA;IACI,mBAAmB;AACvB;;AAEA,gBAAgB;AAChB;IACI,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,wCAAwC;AAC5C;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA,gBAAgB;AAChB;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;AAC1B;AACA;IACI,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,OAAO;AACX;;AAEA,sDAAsD;AACtD;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,2DAA2D;IAC3D,eAAe;IACf,2BAA2B;IAC3B,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,uBAAuB;AAC3B;AACA;IACI,OAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA,qDAAqD;AACrD;IACI,YAAY;IACZ,eAAe;IACf,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,eAAe;AACnB;AACA;IACI,6BAA6B;IAC7B,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gCAAgC;IAChC,8BAA8B;IAC9B,mCAAmC;IACnC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;;AAEA,uCAAuC;AACvC;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,2DAA2D;IAC3D,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;AACrC;AACA;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;IACzB,+BAA+B;IAC/B,sBAAsB;IACtB,aAAa;AACjB;;AAEA,uCAAuC;AACvC;IACI,aAAa;IACb,eAAe;IACf,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,2BAA2B;IAC3B,sBAAsB;IACtB,iCAAiC;AACrC;AACA;IACI,eAAe;IACf,oBAAoB;AACxB;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,eAAe;AACnB","sourcesContent":["/* System Configuration dialog: large, responsive, tabbed.\n   Reuses the shared .modal backdrop + .titlebar/.dismiss styling from widgets.css;\n   overrides the default 400px/centered-33% dialog sizing. */\n\n.modal .dialog.system-config {\n    width: min(960px, 92vw);\n    height: min(760px, 88vh);\n    top: 50%;\n    padding-bottom: 0;\n\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n/* tab row */\n.system-config .tabs {\n    display: flex;\n    align-items: stretch;\n    border-bottom: 1px solid var(--black-20);\n    padding: 0 4px;\n    user-select: none;\n}\n\n.system-config .tabs .tab {\n    flex: 1;\n    text-align: center;\n    padding: 16px 8px;\n\n    font-size: 15px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: var(--black-45);\n\n    cursor: pointer;\n    border-bottom: 3px solid transparent;\n    margin-bottom: -1px;\n}\n\n.system-config .tabs .tab:hover {\n    color: var(--black-65);\n}\n\n.system-config .tabs .tab.active {\n    color: var(--black-90);\n    border-bottom-color: var(--black-80);\n}\n\n/* body grows to fill, scrolls if content overflows */\n.system-config .body {\n    flex: 1;\n    overflow-y: auto;\n    margin: 0;\n    padding: 24px;\n}\n\n.system-config .body .placeholder {\n    color: var(--black-45);\n    font-size: 15px;\n}\n\n/* footer pinned at the bottom */\n.system-config .actions {\n    padding: 16px 0 18px;\n    flex: 0 0 auto;\n}\n\n/* ===== MIDI tab ===== */\n.system-config .midi-tab {\n    max-width: 680px;\n    margin: 0 auto;\n}\n\n.system-config .section-label {\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    color: var(--blue-2);\n    margin: 0 0 10px;\n}\n\n/* port selector */\n.system-config .midi-ports {\n    margin-bottom: 18px;\n}\n\n.system-config .ports {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    gap: 8px;\n}\n\n.system-config .ports .port {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    height: 30px;\n    padding: 0 12px;\n    border-radius: 15px;\n\n    font-size: 13px;\n    font-weight: 500;\n    white-space: nowrap;\n\n    color: var(--black-65);\n    background-color: transparent;\n    border: 1px solid var(--black-25);\n\n    cursor: pointer;\n    user-select: none;\n}\n\n.system-config .ports .port:hover {\n    color: var(--black-85);\n    border-color: var(--black-35);\n}\n\n.system-config .ports .port .check {\n    font-size: 16px;\n    display: none;\n}\n\n.system-config .ports .port.on {\n    color: var(--black-90);\n    background-color: var(--blue-1);\n    border-color: var(--blue-2);\n}\n\n.system-config .ports .port.on .check {\n    display: inline;\n}\n\n/* selected but disconnected */\n.system-config .ports .port.bad {\n    color: var(--red-3);\n    border-color: var(--red-3);\n    background-color: transparent;\n}\n\n.system-config .ports .port.bad .tag {\n    font-size: 11px;\n    opacity: 0.8;\n}\n\n.system-config .ports .clear {\n    margin-left: auto;\n    font-size: 12px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    color: var(--black-45);\n    cursor: pointer;\n    padding: 0 4px;\n}\n\n.system-config .ports .clear:hover {\n    color: var(--black-80);\n}\n\n/* embedded MIDI manager fills the tab column */\n.system-config .midi-browser.embed {\n    width: 100%;\n}\n\n/* category filter bubbles (MIDI tab) — let the filter row span the full width */\n.system-config .midi-browser.embed > .header {\n    width: 100%;\n}\n.system-config .midi-browser.embed .header .left {\n    gap: 12px;\n}\n.system-config .midi-browser.embed .cat-filters {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n.system-config .midi-browser.embed .cat-filter {\n    width: 26px;\n    height: 26px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 13px;\n    cursor: pointer;\n    user-select: none;\n    color: var(--black-45);\n    border: 1px solid transparent;\n}\n.system-config .midi-browser.embed .cat-filter .symbols {\n    font-size: 17px;\n}\n.system-config .midi-browser.embed .cat-filter:hover {\n    color: var(--black-85);\n    background: var(--black-10);\n}\n.system-config .midi-browser.embed .cat-filter.active {\n    color: var(--black-90);\n    background: var(--blue-1);\n    border-color: var(--blue-2);\n}\n\n/* MIDI tab: \"where these settings are saved\" reference (collapsible) */\n.system-config .storage-ref {\n    margin-top: 16px;\n    background: var(--black-02);\n    border: 1px solid var(--black-10);\n    border-radius: 5px;\n    padding: 8px 12px;\n}\n.system-config .storage-ref > summary {\n    cursor: pointer;\n    color: var(--black-65);\n    font-size: 12.5px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    user-select: none;\n}\n.system-config .storage-ref > summary:hover {\n    color: var(--black-85);\n}\n.system-config .storage-ref .intro {\n    color: var(--black-65);\n    font-size: 13px;\n    line-height: 1.5;\n    margin: 12px 0 14px;\n}\n\n/* level table */\n.system-config .lvl-table {\n    width: 100%;\n    border-collapse: collapse;\n    font-size: 12.5px;\n    margin-bottom: 16px;\n}\n.system-config .lvl-table th {\n    text-align: left;\n    color: var(--black-45);\n    font-weight: 600;\n    padding: 4px 10px;\n    border-bottom: 1px solid var(--black-15);\n    font-size: 11px;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n.system-config .lvl-table td {\n    padding: 6px 10px;\n    border-bottom: 1px solid var(--black-10);\n    color: var(--black-80);\n}\n.system-config .lvl-table tr:last-child td {\n    border-bottom: none;\n}\n\n/* level badge */\n.system-config .badge {\n    display: inline-block;\n    font-size: 10.5px;\n    font-weight: 700;\n    letter-spacing: 0.03em;\n    padding: 2px 7px;\n    border-radius: 10px;\n    white-space: nowrap;\n}\n.system-config .badge.machine {\n    color: #e7b766;\n    background: rgba(231,183,102,0.13);\n    border: 1px solid rgba(231,183,102,0.45);\n}\n.system-config .badge.session {\n    color: #6fc3a6;\n    background: rgba(111,195,166,0.13);\n    border: 1px solid rgba(111,195,166,0.45);\n}\n\n/* icon legend */\n.system-config .legend-title {\n    color: var(--black-45);\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.06em;\n    text-transform: uppercase;\n    margin: 0 0 8px;\n}\n.system-config .legend {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n}\n.system-config .legend .row {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    font-size: 12.5px;\n}\n.system-config .legend .ico {\n    width: 22px;\n    flex: 0 0 22px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: var(--black-65);\n}\n.system-config .legend .ico .symbols {\n    font-size: 17px;\n}\n.system-config .legend .ico .nodeicon {\n    width: 15px;\n    height: 15px;\n}\n.system-config .legend .lbl {\n    color: var(--black-85);\n    font-weight: 600;\n    min-width: 78px;\n}\n.system-config .legend .desc {\n    color: var(--black-45);\n    flex: 1;\n}\n\n/* ===== Devices + Backup tabs (shared layout) ===== */\n.system-config :is(.devices-pane, .backup-pane) {\n    max-width: 680px;\n    margin: 0 auto;\n}\n\n.system-config :is(.devices-tab, .backup-tab) .help {\n    color: var(--black-65);\n    line-height: 1.55;\n    margin: 0 0 14px;\n    font-size: 13.5px;\n}\n.system-config :is(.devices-tab, .backup-tab) .help b {\n    color: var(--black-85);\n    font-weight: 600;\n}\n.system-config :is(.devices-tab, .backup-tab) code {\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 12px;\n    background: var(--black-10);\n    color: var(--black-85);\n    padding: 1px 5px;\n    border-radius: 3px;\n}\n\n.system-config :is(.devices-tab, .backup-tab) .block.tight {\n    margin-bottom: 16px;\n}\n\n/* Export / Import side-by-side cards */\n.system-config :is(.devices-tab, .backup-tab) .cards {\n    display: flex;\n    gap: 14px;\n    margin-bottom: 14px;\n}\n.system-config :is(.devices-tab, .backup-tab) .card {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    background: var(--black-02);\n    border: 1px solid var(--black-10);\n    border-radius: 6px;\n    padding: 14px 16px 16px;\n}\n.system-config :is(.devices-tab, .backup-tab) .card .help {\n    flex: 1;\n    margin-bottom: 12px;\n}\n\n.system-config :is(.devices-tab, .backup-tab) .action-row {\n    display: flex;\n    margin-top: 4px;\n}\n\n/* buttons (Export primary / Import danger-outline) */\n.system-config :is(.devices-tab, .backup-tab) .cta {\n    height: 34px;\n    padding: 0 18px;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    letter-spacing: 0.02em;\n    white-space: nowrap;\n}\n.system-config :is(.devices-tab, .backup-tab) .cta .symbols {\n    font-size: 18px;\n}\n.system-config :is(.devices-tab, .backup-tab) .cta.danger {\n    background-color: transparent;\n    color: var(--red-3);\n    border: 1px solid var(--red-3);\n    box-shadow: none;\n}\n.system-config :is(.devices-tab, .backup-tab) .cta.danger:hover {\n    background-color: rgba(236,115,106,0.10);\n    color: var(--red-3);\n}\n\n/* destructive warning banner */\n.system-config :is(.devices-tab, .backup-tab) .warn {\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n    background: rgba(183,40,40,0.12);\n    border: 1px solid var(--red-1);\n    border-left: 3px solid var(--red-3);\n    border-radius: 4px;\n    padding: 10px 12px;\n    margin: 0 0 14px;\n}\n.system-config :is(.devices-tab, .backup-tab) .warn .symbols {\n    color: var(--red-3);\n    font-size: 20px;\n    flex: 0 0 auto;\n}\n.system-config :is(.devices-tab, .backup-tab) .warn .txt {\n    color: var(--black-80);\n    line-height: 1.5;\n    font-size: 13px;\n}\n.system-config :is(.devices-tab, .backup-tab) .warn .txt b {\n    color: var(--red-3);\n}\n\n/* CSV column reference (collapsible) */\n.system-config :is(.devices-tab, .backup-tab) details {\n    background: var(--black-02);\n    border: 1px solid var(--black-10);\n    border-radius: 5px;\n    padding: 8px 12px;\n}\n.system-config :is(.devices-tab, .backup-tab) summary {\n    cursor: pointer;\n    color: var(--black-65);\n    font-size: 12.5px;\n    font-weight: 600;\n    letter-spacing: 0.04em;\n    user-select: none;\n}\n.system-config :is(.devices-tab, .backup-tab) summary:hover {\n    color: var(--black-85);\n}\n.system-config :is(.devices-tab, .backup-tab) .cols {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 12px;\n}\n.system-config :is(.devices-tab, .backup-tab) .col {\n    font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n    font-size: 11.5px;\n    padding: 3px 8px;\n    border-radius: 3px;\n    background: var(--black-10);\n    color: var(--black-65);\n    border: 1px solid var(--black-15);\n}\n.system-config :is(.devices-tab, .backup-tab) .col.req {\n    color: var(--black-90);\n    border-color: var(--blue-2);\n    background: var(--blue-1);\n}\n.system-config :is(.devices-tab, .backup-tab) .cols-note {\n    margin-top: 10px;\n    color: var(--black-45);\n    font-size: 12px;\n}\n.system-config :is(.devices-tab, .backup-tab) .cols-note .req-swatch {\n    display: inline-block;\n    width: 9px;\n    height: 9px;\n    border-radius: 2px;\n    background: var(--blue-1);\n    border: 1px solid var(--blue-2);\n    vertical-align: middle;\n    margin: 0 3px;\n}\n\n/* Backup: \"what's in a backup\" chips */\n.system-config .backup-tab .items {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n    margin-top: 12px;\n}\n.system-config .backup-tab .item {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    font-size: 12px;\n    padding: 3px 9px 3px 7px;\n    border-radius: 12px;\n    background: var(--black-10);\n    color: var(--black-80);\n    border: 1px solid var(--black-15);\n}\n.system-config .backup-tab .item .symbols {\n    font-size: 14px;\n    color: var(--blue-2);\n}\n.system-config .backup-tab .items-note {\n    margin-top: 10px;\n    color: var(--black-45);\n    font-size: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
